const type = 'SET_TOTAL_DUE_ERROR';

const setTotalDueError = (data) => ({
  type,
  data,
});

export default setTotalDueError;
